import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

type FixTextButtonProps = {
  handleFix: () => void;
};

export function FixTextButton({ handleFix }: FixTextButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      size="small"
      variant="text"
      onClick={handleFix}
      data-testid="save-asset-fix-button"
      sx={{
        padding: '0 0.5rem',
        minWidth: 'auto',
        color: 'text.secondary',
        textTransform: 'none',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        verticalAlign: 'baseline',
      }}
    >
      {t('library.save_dialog_fix_button')}
    </Button>
  );
}
